var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RouterLink',{staticClass:"lib-btn-menu",style:({ color: _vm.$vuetify.theme.currentTheme.text }),attrs:{"to":_vm.to}},[_c('div',{staticClass:"btn-text"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"btn-line-cont"},[_c('div',{staticClass:"btn-line"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }